module.exports = __webpack_public_path__ + "img/expostyle_0906_sahara_beige.d0ea0150.jpg";